module.exports = __webpack_public_path__ + "img/french.4d1fbde1.svg";